/** @prettier */

/**
 * レイアウト設定ダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useState} from 'react';
import InfoIcon from '@mui/icons-material/Info';
import {DndProvider} from 'react-dnd';
import {TouchBackend} from 'react-dnd-touch-backend';
import {useParams} from 'react-router-dom';

//MTH component import
import DragDrop from './DnD/Container';
import APIErrorMessage from '../APIErrorMessage';
//API import
import {
  patchCompositionsGroups,
  getCompositionsGroupsByGroupID,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';
//type import
import {layoutUnitListType} from '../../Type/TypeDef';

import {useTranslation} from 'react-i18next';
import {PrimaryButton, SecondaryButton} from '../BasicButton';

const LayoutSettingDialog = (props: {
  groupInfo: apiIF.res.getCompositionsGroupsByGroupID;
  setGroupInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsGroupsByGroupID | null>
  >;
  layoutImage: string | null;
  isOpenDialog: boolean;
  setIsOpenDialog: (arg0: boolean) => void;
  unitList?: layoutUnitListType;
}) => {
  //パスパラメータ取得
  const {siteID, groupID} = useParams();

  const [groupUnitInfo, setGroupUnitInfo] = useState<
    {
      'unit-id': string;
      'unit-name': string;
      'x-coordinate': string;
      'y-coordinate': string;
    }[]
  >(props.groupInfo['unit-informations']); //グループに登録されている空調機情報
  const [saveBtnDisabled, setSaveBtnDisabled] = useState(false); //SAVEボタン非表示フラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  const trans = useTranslation().t; //翻訳関数

  /**
   * SAVEボタン押下時処理
   */
  const saveLayout = () => {
    //パスパラメータを取得できない場合
    //グループの情報を取得できない場合
    if (
      siteID === undefined ||
      groupID === undefined ||
      props.groupInfo === null
    ) {
      return;
    }

    setSaveBtnDisabled(true);
    setAPIWait(true);

    //編集情報の作成
    const editGroupLayout: apiIF.reqParameters.patchCompositionsGroups = {
      'unit-informations': groupUnitInfo,
    };
    patchCompositionsGroups(siteID, groupID, editGroupLayout)
      .then(() => {
        //グループの情報を取得
        return getCompositionsGroupsByGroupID(siteID, groupID);
      })
      .then(response => {
        props.setGroupInfo(response);
        handleClose();
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setSaveBtnDisabled(false);
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        aria-labelledby="form-dialog-title"
        id="js-setIconDialog"
        maxWidth="md">
        <DialogTitle id="form-dialog-title">
          {trans('LayoutSettingDialog.dialogBox.title')}
        </DialogTitle>
        <DialogContent>
          {/* ダイアログに表示するメッセージ */}
          <DialogContentText>
            <InfoIcon color="primary" style={{fontSize: 13}} />
            {trans('LayoutSettingDialog.dialogBox.msg')}
          </DialogContentText>
          {/* レイアウト画像の表示 */}
          <DndProvider
            backend={TouchBackend}
            options={{
              enableMouseEvents: true,
              enableKeyboardEvents: true,
            }}>
            <DragDrop
              image={props.layoutImage}
              groupUnitInfo={props.groupInfo['unit-informations']} //修正前の値を入力しないとCANCELしたときに前回値が残る
              setGroupUnitInfo={setGroupUnitInfo}
              unitList={props.unitList}
            />
          </DndProvider>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('LayoutSettingDialog.dialogBox.buttonTxt.cancel')}
            id={'mv-setIconCancelBtn'}
          />
          <PrimaryButton
            onClick={saveLayout}
            buttonText={trans('LayoutSettingDialog.dialogBox.buttonTxt.save')}
            id="js-setIconSaveBtn"
            disabled={saveBtnDisabled}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id={'mv-layoutSettingErrDlgBtn'}
      />
    </>
  );
};
export default LayoutSettingDialog;
